module.exports = __webpack_public_path__ + "img/mask_group.4dfe5ab0.png";